import React from 'react';
import PropTypes from 'prop-types';

import { Box, Card, CardActionArea, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';

import { COLORS } from '../../../Constant/COLORS';

import { toCurrencyString } from '../../../Helpers';

function PackageCard({ title, price, features = [], onClick }) {
  return (
    <Card
      sx={{
        height: '100%',
        transition:
          'transform .2s ease, box-shadow .2s ease, border-color .2s ease',
        '&:hover': {
          transform: 'translateY(-3px)',
          borderColor: COLORS.teal,
          boxShadow: '0 12px 28px rgba(14, 27, 31, 0.10)',
        },
      }}>
      <CardActionArea sx={{ height: '100%', p: 2.5 }} onClick={onClick}>
        <Box height='inherit'>
          <Typography
            variant='h5'
            component='h3'
            mb={1}
            whiteSpace='nowrap'
            textOverflow='ellipsis'
            overflow='hidden'>
            {title}
          </Typography>

          <Typography variant='h4' color={COLORS.teal} fontWeight={700} mb={0.5}>
            {toCurrencyString(price)}
          </Typography>

          {features.length > 0 && (
            <Stack spacing={1} mt={2}>
              {features.map((feature, i) => (
                <Stack key={i} direction='row' alignItems='center' gap={1}>
                  <CheckCircleIcon fontSize='small' color='success' />
                  <Typography variant='body2' color={COLORS.inkSoft}>
                    {feature}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          )}
        </Box>
      </CardActionArea>
    </Card>
  );
}

PackageCard.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  features: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func.isRequired,
};

export default PackageCard;
